var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"standard-for-charge-wrapper"},[_c('img',{attrs:{"src":"https://files.jinr.com/jinr-index/img/standard-for-charge.png","alt":"","srcset":""}})])
}]

export { render, staticRenderFns }